import { smBumps, TextInput } from '@wrisk/ui-components'
import React, { ChangeEvent, FunctionComponent, useState } from 'react'
import { Controller, useFormContext } from 'react-hook-form'

import { ErrorMessage } from '../../../../../infrastructure/formBuilder'
import {
  TKeyBuilder,
  useWriskTranslation,
} from '../../../../../infrastructure/internationalisation'

export interface QuoteProposalCodeInputProps {
  name: string
  tKey: TKeyBuilder
  proposalCode: {
    validation: string
  }
}

const MAX_LENGTH = 10
export const QuoteProposalCodeFormInput: FunctionComponent<
  QuoteProposalCodeInputProps
> = ({ name, tKey, proposalCode }) => {
  const { t } = useWriskTranslation()

  const [value, setValue] = useState<string | undefined>('')
  const { control } = useFormContext()

  const onInputChange =
    (onChange: (value: string | undefined) => void) =>
    ({ target }: ChangeEvent<HTMLInputElement>) => {
      const text = target.value.replace(/\D/g, '')

      if (text.length <= MAX_LENGTH) {
        setValue(text)
        onChange(text)
      }
    }

  return (
    <>
      <Controller
        name={name}
        control={control}
        rules={{ required: true, pattern: RegExp(proposalCode.validation) }}
        render={({ field: { onChange, onBlur } }) => (
          <TextInput
            value={value}
            placeholder={t<string>(tKey('placeholder'))}
            onChange={onInputChange(onChange)}
            onBlur={onBlur}
          />
        )}
      />
      <ErrorMessage name={name} tKey={tKey} t={t} tName='' pt={smBumps} />
    </>
  )
}
